import React from "react";

const Denmark = () => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 20 15"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="15"
        id="mask0_305_22339"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="20"
        x="0"
        y="0"
      >
        <rect fill="white" height="15" width="20" />
      </mask>
      <g mask="url(#mask0_305_22339)">
        <path
          clipRule="evenodd"
          d="M0 0V15H20V0H0Z"
          fill="#C51918"
          fillRule="evenodd"
        />
        <mask
          height="15"
          id="mask1_305_22339"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          width="20"
          x="0"
          y="0"
        >
          <path
            clipRule="evenodd"
            d="M0 0V15H20V0H0Z"
            fill="white"
            fillRule="evenodd"
          />
        </mask>
        <g mask="url(#mask1_305_22339)">
          <path
            clipRule="evenodd"
            d="M6 0H9V6H20V9H9V15H6V9H0V6H6V0Z"
            fill="#F7FCFF"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};

export default Denmark;
